import styled from 'styled-components'

const H6 = styled.h6`
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  margin: 0;
`

export default H6
